import { apiService } from "@/common/api.service.js";

export default {
  // Opportunities
  getAllOpportunities() {
    const endpoint = `/api/opportunity-all/`;
    return apiService(endpoint);
  },


  searchOpportunityQuery(searchQuery) {
    const endpoint = `/api/opportunities/?search=${encodeURIComponent(searchQuery)}`;
    return apiService(endpoint);
  },

  siteOpportunities(site) {
    const endpoint = `/api/opportunities/?site_code__id=${site}`;
    return apiService(endpoint);
  },

  siteCodeOpportunities(site) {
    const endpoint = `/api/opportunities/?site_code__site_code=${site}`;
    return apiService(endpoint);
  },

  seuOpportunities(seu) {
    const endpoint = `/api/opportunities/?seu__id=${seu}`;
    return apiService(endpoint);
  },

  opportunityData(opportunityId) {
    const endpoint = `/api/opportunities/${opportunityId}/`;
    return apiService(endpoint);
  },

  opportunityId(opportunity_number) {
    const endpoint = `/api/opportunity-id/${opportunity_number}/`;
    return apiService(endpoint);
  },

  opportunityStatusDetails(opportunityId) {
    const endpoint = `/api/opportunity-status-details/${opportunityId}/`;
    return apiService(endpoint);
  },

  changeOpportunityStatusDetails(payload) {
    const endpoint = `/api/opportunity-status-details/${payload.opportunity_id}/`;
    return apiService(endpoint, "POST", payload);
  },

  opportunityCreate(payload) {
    const endpoint = `/api/opportunity-create/`;
    return apiService(endpoint, "POST", payload);
  },

  opportunityUpdate(payload) {
    const endpoint = `/api/opportunity-update/${payload.id}/`;
    return apiService(endpoint, "PATCH", payload);
  },

  changeOpportunityStatus(payload) {
    const endpoint = `/api/opportunity-status/${payload.id}/`;
    return apiService(endpoint, "POST", payload);
  },

  opportunityComments(opportunityNumber) {
    const endpoint = `/api/opportunity-comment/${opportunityNumber}`;
    return apiService(endpoint);
  },

  createOpportunityComment(payload) {
    const endpoint = `/api/opportunity-comment/${payload.opportunity_number}`;
    return apiService(endpoint, "POST", payload);
  },

  // Site/SEU views
  siteView(id) {
    const endpoint = `/api/site/${id}/`;
    return apiService(endpoint);
  },

  siteSeuView(site_id, seu_id) {
    const endpoint = `/api/seu/${site_id}/${seu_id}/`;
    return apiService(endpoint);
  },


  // Pagination
  nextPage(next) {
    return apiService(next);
  },
};
